export default "__VITE_ASSET__BZgiwMqC__"